import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { trackEvent } from '@nobia/zeus-components/lib/analytics'
import styled from '@nobia/zeus-components/lib/styled'
import ProductCodeInput from '../product-code-input/ProductCodeInput'
import { cdnImage } from '../../utils'

const image = cdnImage(require('../../assets/close.svg'))

const Modal = styled.div`
  position: fixed;
  display: block;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
  outline: 0;
`

const ModalDialog = styled.div`
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  margin: 0;
`

const ModalContent = styled.div`
  position: relative;
  background-color: #fff;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  outline: 0;
  -webkit-box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
  box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
  min-height: 100vh;
  border-radius: 0;
`

const ModalHeader = styled.div`
  display: block;
  padding: 15px;
  text-align: right;
`

const CloseButton = styled.img`
  width: 7%;
  vertical-align: middle;
  border: 0;
`

const ModalBody = styled.div`
  position: relative;
  display: block;
  padding: 15px;
`

class ProductCodeModal extends Component {
  onProductFetch = product => {
    trackEvent('MC-ESH Add Product', 'MC-ESH Click', product.saveId)
    this.props.onProductFetch(product)
    this.props.handleClose()
  }

  render() {
    if (this.props.open) {
      return (
        <Modal>
          <ModalDialog>
            <ModalContent>
              <ModalHeader>
                <CloseButton src={image} onClick={this.props.handleClose} />
              </ModalHeader>
              <ModalBody>
                <ProductCodeInput onProductFetch={this.onProductFetch} />
              </ModalBody>
            </ModalContent>
          </ModalDialog>
        </Modal>
      )
    }
    return <div />
  }
}

ProductCodeModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  onProductFetch: PropTypes.func.isRequired,
}

export default ProductCodeModal
